import { render, staticRenderFns } from "./offerPlansTable.vue?vue&type=template&id=f9130b96&scoped=true"
import script from "./offerPlansTable.vue?vue&type=script&lang=js"
export * from "./offerPlansTable.vue?vue&type=script&lang=js"
import style0 from "./offerPlansTable.vue?vue&type=style&index=0&id=f9130b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9130b96",
  null
  
)

export default component.exports